import React from "react";

interface PanelProps {
  children: React.ReactNode;
}

export const Panel: React.FC<PanelProps> = ({ children }) => {
  return <div className="h-[50vh] overflow-y-auto">{children}</div>;
};
